export default __webpack_public_path__ + "static/media/DMA.d549aa18.png";